"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePortalElement = exports.useFocusLock = exports.useScrollLock = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var focusableTypes = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

var getFocusListener = function getFocusListener(modal) {
  return function (e) {
    var isTabPressed = e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    var focusableElements = modal.querySelectorAll(focusableTypes);
    var firstFocusableElement = focusableElements[0];
    var lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault();
      }
    } else if (document.activeElement === lastFocusableElement) {
      firstFocusableElement.focus();
      e.preventDefault();
    }
  };
};

var useScrollLock = function useScrollLock() {
  (0, _react.useEffect)(function () {
    var body = document.body;
    var scrollY = window.scrollY;
    body.style.position = 'fixed';
    body.style.width = '100%';
    body.style.top = -scrollY + 'px';
    return function () {
      body.style.position = '';
      body.style.width = '';
      body.style.top = '';
      window.scrollTo(0, scrollY || 0 * -1);
    };
  }, []);
};

exports.useScrollLock = useScrollLock;

var useFocusLock = function useFocusLock(el) {
  (0, _react.useEffect)(function () {
    if (el) {
      var focusListener = getFocusListener(el);
      var activeElement = document.activeElement;
      el.focus({
        preventScroll: true
      });
      document.addEventListener('keydown', focusListener);
      return function () {
        // @ts-ignore
        activeElement && activeElement.focus({
          preventScroll: true
        });
        document.removeEventListener('keydown', focusListener);
      };
    }
  }, [el]);
};

exports.useFocusLock = useFocusLock;

var usePortalElement = function usePortalElement() {
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      node = _useState2[0],
      setNode = _useState2[1];

  (0, _react.useEffect)(function () {
    var domNode = document.createElement('div');
    domNode.tabIndex = -1;
    domNode.dataset.testid = 'Portal';
    document.body.appendChild(domNode);
    setNode(domNode);
    return function () {
      document.body.removeChild(domNode);
    };
  }, []);
  return node;
};

exports.usePortalElement = usePortalElement;